/*
 * @providesModule HelpModalStyle
 *
 * Shared styles for the help modal (title + body bottom sheet).
 */

import {Platform, StyleSheet} from 'react-native';

export const helpModalStyles = StyleSheet.create({
  container: {
    paddingHorizontal: 32,
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontFamily: 'OpenSans-Bold',
    fontStyle: 'normal',
    fontWeight: Platform.OS !== 'ios' ? 'bold' : '700',
    fontSize: 20,
    lineHeight: 28,
    color: '#000',
    textAlign: 'left',
    width: '100%',
    marginTop: 32,
  },
  body: {
    color: 'rgba(0, 0, 0, 0.9)',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '400',
    fontStyle: 'normal',
    fontFamily: 'OpenSans-Regular',
    marginTop: 16,
    marginBottom: 32,
    width: '100%',
  },
  contentWrapper: {
    marginHorizontal: 16,
    width: 'auto',
  },
});
